'use client';

import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { PersonForm } from '@/components/admin/people/PersonForm';
import { getPersonById } from '@/lib/actions/people';

export default function AdminPersonEditPage() {
  const { id } = useParams<{ id: string }>();
  const [person, setPerson] = useState<Awaited<ReturnType<typeof getPersonById>>>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    getPersonById(id).then((data) => {
      setPerson(data);
      setLoading(false);
    });
  }, [id]);

  if (loading) {
    return null;
  }

  if (!person) {
    return <Navigate to="/admin/people" replace />;
  }

  return <PersonForm initialData={person} />;
}
